import { getMemberInfo } from '../api/getMemberInfo';
import { useQuery } from '@tanstack/react-query';
import { queryKey } from 'shared/src/constant';

export const useMyInfo = () => {
  return useQuery({
    queryKey: queryKey.myInfo,
    queryFn: getMemberInfo,
  });
};
